import { useEffect, useState } from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import WhySection from '../components/WhySection';
import BFBMethodSection from '../components/BFBMethodSection';
import ServicesSection from '../components/ServicesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';
import FloatingChatButton from '../components/FloatingChatButton';
import LeadMagnetPopup from '../components/LeadMagnetPopup';

const Home = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#f8f6f3' }}>
      <Navigation scrolled={scrolled} />
      <HeroSection />
      <AboutSection />
      <WhySection />
      <BFBMethodSection />
      <ServicesSection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
      <FloatingChatButton />
      <LeadMagnetPopup />
    </div>
  );
};

export default Home;
